export type Nullable<T> = {
    [K in keyof T]: T[K] extends object ? Nullable<T[K]> : T[K] | undefined
}

export function makeNullable<T>(obj: T): Nullable<T> {
    const result: any = Array.isArray(obj) ? [] : {}

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key]
            result[key] = value !== null && typeof value === 'object' ? makeNullable(value) : value
        }
    }

    return result as Nullable<T>
}
